<h1 class="calibrates-theme" mat-dialog-title>
  {{ 'particleEdit.dialog.test.title.create' | translate }}
  @if ([3, 10, 2, 9].includes(data.test.idTestType) && (![3, 10].includes(data.test.idTestType) || data.test.results.length < 3)) {
    <button
      mat-icon-button color="accent" (click)="addTestResult(data.test)" [disabled]="isEditable()">
      <mat-icon>add</mat-icon>
    </button>
  }
</h1>

<form>
  <div mat-dialog-content class="calibrates-theme">
    <div fxLayout="column" fxLayoutGap="24px">

      <div fxFlex="100">
        <mat-form-field class="campoFormulario" appearance="fill">
          <mat-label>{{ 'protocolEdit.dialog.equipment.type.label' | translate }}</mat-label>
          <input matInput [value]="data.name" readonly disabled />
        </mat-form-field>
      </div>

      @for (result of data.test.results; track result; let i = $index) {
        <div fxLayout="row wrap" fxLayoutGap="24px">
          <!-- Nominal -->
          @if (showNominal()) {
            <div fxFlex="20" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario" appearance="fill">
                <mat-label>{{ 'particlesTest.dialog.test.nominal.label' | translate }}</mat-label>
                <input matInput type="number" [(ngModel)]="result.nominal"
                  (ngModelChange)="calculateResult(result,data.test.idTestType)" name="nominal-{{i}}" required />
                <mat-error>
                  {{ 'particlesTest.dialog.test.nominal.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          }
          <!-- Canal -->
          @if (showChannel()) {
            <div fxFlex="20" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario" appearance="fill">
                <mat-label>{{ 'particlesTest.dialog.test.channel.label' | translate }}</mat-label>
                <mat-select required name="idSize-{{i}}" [(ngModel)]="result.channelPha">
                  @for (item of particleSizes; track item) {
                    <mat-option [value]="item.size">
                      {{ item.size }}
                    </mat-option>
                  }
                </mat-select>
                <mat-error>
                  {{ 'particlesTest.dialog.test.channel.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          }
          <!-- Valor anterior -->
          @if (showPreviousValue()) {
            <div fxFlex="20" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario" appearance="fill">
                <mat-label>{{ 'particlesTest.dialog.test.previousValue.label' | translate }}</mat-label>
                <input matInput [(ngModel)]="result.previousValue"
                  (ngModelChange)="calculateResult(result,data.test.idTestType)" name="previousValue-{{i}}" required />
                <mat-error>
                  {{ 'particlesTest.dialog.test.previousValue.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          }
          <!-- Cuentas observadas -->
          @if (showObsAccounts()) {
            <div fxFlex="20" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario" appearance="fill">
                <mat-label>{{ 'particlesTest.dialog.test.obs_account.label' | translate }}</mat-label>
                <input matInput type="number" [(ngModel)]="result.obsAccount" name="obs_account-{{i}}"
                  (ngModelChange)="falseCountPass(result)" required />
                <mat-error>
                  {{ 'particlesTest.dialog.test.obs_account.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          }
          <!-- Tamaño certificado -->
          @if (showSizeCertificate()) {
            <div fxFlex="20" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario" appearance="fill">
                <mat-label>{{ 'particlesTest.dialog.test.cert_size.label' | translate }}</mat-label>
                <input matInput [(ngModel)]="result.certSize" name="cert_size-{{i}}" required />
                <mat-error>
                  {{ 'particlesTest.dialog.test.cert_size.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          }
          <!-- Resolución obtenida (%) -->
          @if (showObtResolucion()) {
            <div fxFlex="20" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario" appearance="fill">
                <mat-label>{{ 'particlesTest.dialog.test.obt_resolution.label' | translate }}</mat-label>
                <input matInput [(ngModel)]="result.obtResolution" name="obt_resolution-{{i}}" required />
                <mat-error>
                  {{ 'particlesTest.dialog.test.obt_resolution.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          }
          <!-- Tiempo del contador  -->
          @if (showCountTime()) {
            <div fxFlex="20" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario" appearance="fill">
                <mat-label>{{ 'particlesTest.dialog.test.count_time.label' | translate }}</mat-label>
                <input matInput [(ngModel)]="result.countTime" name="count_time-{{i}}"
                  (ngModelChange)="calculateResult(result,data.test.idTestType)" required />
                <mat-error>
                  {{ 'particlesTest.dialog.test.count_time.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          }
          <!-- Tiempo del patrón  -->
          @if (showStandarTime()) {
            <div fxFlex="20" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario" appearance="fill">
                <mat-label>{{ 'particlesTest.dialog.test.standar_time.label' | translate }}</mat-label>
                <input matInput [(ngModel)]="result.standarTime" name="standar_time-{{i}}"
                  (ngModelChange)="calculateResult(result,data.test.idTestType)" required />
                <mat-error>
                  {{ 'particlesTest.dialog.test.standar_time.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          }
          <!-- Mediana -->
          @if (showMedian()) {
            <div fxFlex="20" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario" appearance="fill">
                <mat-label>{{ 'particlesTest.dialog.test.median.label' | translate }}</mat-label>
                <input matInput [(ngModel)]="result.median" name="median-{{i}}" required />
                <mat-error>
                  {{ 'particlesTest.dialog.test.median.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          }
          <!-- Valor ajustado -->
          @if (showAjustedValue()) {
            <div fxFlex="20" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario" appearance="fill">
                <mat-label>{{ 'particlesTest.dialog.test.ajustedValue.label' | translate }}</mat-label>
                <input matInput [(ngModel)]="result.ajustedValue"
                  (ngModelChange)="calculateResult(result,data.test.idTestType)" name="ajustedValue-{{i}}" required />
                <mat-error>
                  {{ 'particlesTest.dialog.test.ajustedValue.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          }
          <!-- Ruido medido -->
          @if (showMeasuredNoise()) {
            <div fxFlex="20" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario" appearance="fill">
                <mat-label>{{ 'particlesTest.dialog.test.measuredNoise.label' | translate }}</mat-label>
                <input matInput [(ngModel)]="result.noise" name="noise-{{i}}"
                  (ngModelChange)="calculateResult(result,data.test.idTestType)" required/>
                <mat-error>
                  {{ 'particlesTest.dialog.test.measuredNoise.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          }
          <!-- Señal medida -->
          @if (showMeasuredSignal()) {
            <div fxFlex="20" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario" appearance="fill">
                <mat-label>{{ 'particlesTest.dialog.test.measuredSignal.label' | translate }}</mat-label>
                <input matInput [(ngModel)]="result.signal" name="signal-{{i}}"
                  (ngModelChange)="calculateResult(result,data.test.idTestType)" required />
                <mat-error>
                  {{ 'particlesTest.dialog.test.measuredSignal.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          }
          <!-- Measured -->
          @if (showMessuared()) {
            <div fxFlex="20" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario" appearance="fill">
                <mat-label>{{ 'particlesTest.dialog.test.measured.label' | translate }}</mat-label>
                <input matInput type="number " [(ngModel)]="result.measured"
                  (ngModelChange)="calculateResult(result,data.test.idTestType)" name="measured-{{i}}" required />
                <mat-error>
                  {{ 'particlesTest.dialog.test.measured.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          }
          <!-- Ensayo de eficiencia (%) -->
          @if (showEfficiencyTest()) {
            <div fxFlex="20" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario" appearance="fill">
                <mat-label>{{ 'particlesTest.dialog.test.efficiencyTest.label' | translate }}</mat-label>
                <input matInput [(ngModel)]="result.efficiencyTest" name="efficiencytest-{{i}}" required />
                <mat-error>
                  {{ 'particlesTest.dialog.test.efficiencyTest.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          }
          <!-- Eficiencia obtenida (%) -->
          @if (showObtainedEfficiency()) {
            <div fxFlex="20" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario" appearance="fill">
                <mat-label>{{ 'particlesTest.dialog.test.obtainedEfficiency.label' | translate }}</mat-label>
                <input matInput [(ngModel)]="result.obtainedEfficiency" name="obtainedEfficiency-{{i}}" required />
                <mat-error>
                  {{ 'particlesTest.dialog.test.obtainedEfficiency.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          }
          <!-- Tamaño partícula -->
          @if (showSize()) {
            <div fxFlex="20" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario" appearance="fill">
                <mat-label>{{ 'particlesTest.dialog.test.size.label' | translate }}</mat-label>
                <input matInput [(ngModel)]="result.size" name="size-{{i}}" required />
                <mat-error>
                  {{ 'particlesTest.dialog.test.size.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          }
          <!-- Limit -->
          @if (showLimit()) {
            <div fxFlex="20" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario" appearance="fill">
                <mat-label>{{ 'particlesTest.dialog.test.limit.label' | translate }}</mat-label>
                <input matInput [(ngModel)]="result.limit" name="limit-{{i}}" [disabled]="!isLimitEditable()"
                  (ngModelChange)="calculateResult(result,data.test.idTestType)" required />
                <mat-error>
                  {{ 'particlesTest.dialog.test.limit.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          }
          <div fxFlex="20" fxFlex.lt-md="100%">
            <mat-form-field class="campoFormulario">
              <mat-label>{{'particlesTest.dialog.test.uncertainty.label' | translate }}</mat-label>
              <input matInput type="number" [(ngModel)]="result.uncertainty" name="uncertainty-{{i}}">
              <mat-error>
                {{ 'particlesTest.dialog.test.uncertainty.error' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <!-- Result -->
          @if (showResult()) {
            <div fxFlex="20" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario" appearance="fill">
                <mat-label>{{'particlesTest.dialog.test.result.label' | translate }}</mat-label>
                <input matInput [ngModel]="result.result" name="result-{{i}}" disabled required />
                <mat-error>
                  {{ 'particlesTest.dialog.test.result.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          }
          <!-- Pass -->
          <div fxFlex="10" fxFlex.lt-md="100%">
            <mat-checkbox matTooltip="{{ 'particlesTest.dialog.test.pass.label' | translate }}"
              name="pass-{{indexResult}}" [checked]="result.pass" (change)="onPassChange($event.checked, result)"
              [disabled]="isEditable()">
              {{ 'particlesTest.dialog.test.pass.label' | translate }}
            </mat-checkbox>
          </div>
          <!-- Fail -->
          <div fxFlex="10" fxFlex.lt-md="100%">
            <mat-checkbox matTooltip="{{ 'particlesTest.dialog.test.fail.label' | translate }}"
              name="fail-{{indexResult}}" [checked]="result.fail" (change)="onFailChange($event.checked, result)"
              [disabled]="isEditable()">
              {{ 'particlesTest.dialog.test.fail.label' | translate }}
            </mat-checkbox>
          </div>
          <!-- Botón para eliminar-->
          @if ([3, 10, 2, 9].includes(data.test.idTestType)) {
            <div fxFlex="5">
              <button mat-icon-button color="accent" (click)="removeTestResult(i)" [disabled]="isEditable()">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <div mat-dialog-actions class="air-theme" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="12px">
    <button mat-raised-button color="primary" (click)="onOkClick()">
      {{ 'button.save' | translate }}
    </button>
    <button mat-raised-button color="secondary" (click)="onNoClick()">
      {{ 'button.cancel' | translate }}
    </button>
  </div>
</form>